const config = {
    base_url: "https://hermesgent.be", //zonder slash op einde
    api_url: "https://old.backend.hermesgent.be", //zonder slash op einde
    active_year: 2022
};

export default config;
